import { useMemo } from 'react'
import { useControlledSwr } from '../../../hooks/use-controlled-swr'
import { useFetch } from '../../../hooks/use-fetch'
import { RequestMethodsEnum } from '../../../hooks/use-fetch/types'
import useUser from '../../../hooks/use-user'
import {
  EmailFooterDataInterface,
  EmailFooterDataListInterface,
} from '../types/email-footer-interface'

export const useEmailFooterData = () => {
  const { user } = useUser()

  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.get, EmailFooterDataListInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: emailFooterData, mutate } = useControlledSwr(
    () => user && [`/api/dashboard/mailing-service/email-footer`],
    fetcher,
  )

  const lastUpdatedFooter = useMemo<EmailFooterDataInterface | null>(() => {
    if (!emailFooterData?.items?.length) return null

    const validItems = emailFooterData.items.filter(
      (item): item is EmailFooterDataInterface & { updatedAt: string } => item.updatedAt !== null,
    )

    if (validItems.length === 0) return null

    return validItems.reduce((latest, item) => {
      if (!latest.updatedAt) return item
      return new Date(item.updatedAt) > new Date(latest.updatedAt) ? item : latest
    }, validItems[0])
  }, [emailFooterData])

  return {
    emailFooterData,
    isFetchingEmailFooterData: isFetching,
    lastUpdatedFooter,
    mutateEmailFooterData: mutate,
  }
}
